import React from "react";
import { cn } from "@/lib/utils";
import { SKILL_CATEGORY_LABELS } from "@/lib/constants";
import { PenLine, Building2, Eye } from "lucide-react";

// Friendly categories: style (the kind of post), industry (domain knowledge),
// critique (auto polish). Voice is no longer a skill — it's a brand entity.
const CATEGORY_CFG = {
  style:    { icon: PenLine,   bg: "rgba(217,119,6,0.10)",  border: "rgba(217,119,6,0.24)",  text: "#B45309" },
  industry: { icon: Building2, bg: "rgba(18, 147, 79,0.10)",  border: "rgba(18, 147, 79,0.24)",  text: "#0B7C42" },
  critique: { icon: Eye,       bg: "rgba(220,38,38,0.10)",  border: "rgba(220,38,38,0.24)",  text: "#B91C1C" },
};

export function SkillBadge({ category, phase, label, className, showIcon = true, ...rest }) {
  const key = category || (phase === "critique" ? "critique" : "style");
  const cfg = CATEGORY_CFG[key] || CATEGORY_CFG.style;
  const Icon = cfg.icon;
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium", className)}
      style={{ backgroundColor: cfg.bg, borderColor: cfg.border, color: cfg.text }}
      data-testid={`skill-badge-${key}`}
      {...rest}
    >
      {showIcon && Icon ? <Icon className="h-3 w-3" /> : null}
      <span>{label || SKILL_CATEGORY_LABELS[key] || key}</span>
    </span>
  );
}
